// src/components/SelectCategory.js
import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// 🔹 i18n
import { useI18n } from '../i18n/I18nContext';

export default function SelectCategory(props) {
  const { feed, category, setCategory } = props;
  const { t } = useI18n();

  const handleChange = (event) => {
    setCategory(event.target.value);
  };

  return (
    <div>
      <FormControl sx={{ marginBottom: 3, marginTop: 0.5, minWidth: 200 }}>
        {/* Antes: <InputLabel>Category</InputLabel> */}
        <InputLabel>{t('selectCategoryLabel')}</InputLabel>
        <Select
          value={category}
          onChange={handleChange}
          autoWidth
          // Antes: label="Category"
          label={t('selectCategoryLabel')}
        >
          {feed.categories
            ? feed.categories.map((cat) => {
                return (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.title}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>
    </div>
  );
}